// Ordering logic UPDATED:
// 1. Sort all events by startTime ASC (earliest -> latest)
// 2. Tie-break by distanceMiles ASC (closest -> furthest)
// 3. Final tie-break by id (stable deterministic)
// (Previous round-robin-by-venue logic removed)

export interface RoundRobinEvent {
  id: string;
  startTime?: any; // Date | Firestore Timestamp | number | string
  location?: { lat?: number | null; lng?: number | null; name?: string | null } | null;
  venue?: { lat?: number | null; lng?: number | null; name?: string | null } | null;
  distanceMiles?: number | null;
  [k: string]: any;
}

function toMs(x: any): number {
  if (!x) return 0;
  if (x instanceof Date) return x.getTime();
  if (typeof x === "number") return x;
  if (typeof x === "string") {
    const t = Date.parse(x);
    return Number.isFinite(t) ? t : 0;
  }
  if (x.toMillis) { try { return x.toMillis(); } catch { return 0; } }
  if (x.toDate)  { try { return x.toDate().getTime(); } catch { return 0; } }
  return 0;
}

export function roundRobinEvents<T extends RoundRobinEvent>(items: T[]): T[] {
  if (!items.length) return items;
  const out = [...items];
  out.sort((a, b) => {
    const ta = toMs(a.startTime);
    const tb = toMs(b.startTime);
    if (ta !== tb) return ta - tb;

    const da = Number.isFinite(a.distanceMiles) ? (a.distanceMiles as number) : Infinity;
    const db = Number.isFinite(b.distanceMiles) ? (b.distanceMiles as number) : Infinity;
    if (da !== db) return da - db;

    return String(a.id).localeCompare(String(b.id));
  });
  return out;
}

// (Optional) If you still need the old venue round-robin, let me know and we can
// reintroduce it under a different export name.
